import React from "react";
import { useAuth } from "../auth/AuthContext";

export default function ContClient() {
  const { client } = useAuth();

  return (
    <div className="cont">
      <div className="dash__head">
        <h1>Contul meu</h1>
        <p>Datele firmei tale și setări de cont.</p>
      </div>

      <div className="cont__card">
        <div className="cont__row">
          <span className="cont__label">Firmă</span>
          <span className="cont__value">{client?.numeFirma}</span>
        </div>
        <div className="cont__row">
          <span className="cont__label">Email</span>
          <span className="cont__value">{client?.email}</span>
        </div>
        <div className="cont__row">
          <span className="cont__label">Telefon</span>
          <span className="cont__value">{client?.telefon}</span>
        </div>
      </div>

      <div className="cont__note">
        Pentru modificarea datelor de cont, contactează echipa LEASEIN.
        Schimbarea parolei va fi disponibilă într-o etapă următoare.
      </div>
    </div>
  );
}
